import Size from "@/util/Size.ts";

export type ViewPort = {
    centerX: number;
    centerY: number;
    visibleWidth: number;
    visibleHeight: number;
};

export type MapTransform = {
    x: number;
    y: number;
    scale: number;
};

export const defaultViewPort: ViewPort = {
    centerX: 400,
    centerY: 300,
    visibleWidth: 800,
    visibleHeight: 600,
};

export const defaultMapTransform: MapTransform = {x: 0, y: 0, scale: 1};

export function toPlayerViewPort(transform: MapTransform, stageSize: Size): ViewPort {
    const scale = Math.max(transform.scale, Number.EPSILON);
    return {
        centerX: (-transform.x + stageSize.width / 2) / scale,
        centerY: (-transform.y + stageSize.height / 2) / scale,
        visibleWidth: stageSize.width / scale,
        visibleHeight: stageSize.height / scale,
    };
}

export function coverViewPort(viewPort: ViewPort, stageSize: Size): MapTransform {
    const scale = Math.max(
        stageSize.width / Math.max(viewPort.visibleWidth, Number.EPSILON),
        stageSize.height / Math.max(viewPort.visibleHeight, Number.EPSILON),
    );
    return {
        x: stageSize.width / 2 - viewPort.centerX * scale,
        y: stageSize.height / 2 - viewPort.centerY * scale,
        scale,
    };
}
